import React from "react";
import { generateAuthUrl } from "../spotify";
import { signOut } from 'firebase/auth';
import { authV9 as auth } from "../firebase";
import "./ConnectSpotify.css";

function ConnectSpotify() {
  const handleLogout = async () => {
    try {
      await signOut(auth);
      // User will be redirected by App.js auth state listener
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  const handleSpotifyConnect = async () => {
    try {
      const authUrl = await generateAuthUrl();
      window.location.href = authUrl;
    } catch (err) {
      console.error("Error generating Spotify auth URL:", err);
    }
  };

  return (
    <div className="connect-spotify-minimal">
      <h1 className="connect-minimal-page-title">Songs to rate</h1>

      <div className="connect-minimal-container">
        <p className="connect-minimal-description">
          In order to play and rate songs and to add your own songs, you have to connect your Spotify account.
        </p>

        <button onClick={handleSpotifyConnect} className="connect-minimal-btn">
          <svg className="connect-minimal-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
          </svg>
          Connect with Spotify Premium
        </button>

        <p className="connect-minimal-info">
          Connecting is safe and secure. Song Carousel uses Spotify's secure OAuth 2.0 login, handled entirely by Spotify. We never see or store your password.
     <br/><br/>

  Song Carousel only uses the following Spotify scopes:<br/>
             "user-modify-playback-state" and
            "user-read-playback-state" to provide its Service.<br/><br/>
         Here you find more information about Spotify <a target="_blank" rel="noopener noreferrer" href="https://developer.spotify.com/documentation/web-api/concepts/scopes" style={{ color: '#ffffff', textDecoration: 'underline' }}>API Scopes</a>.
            <br/><br/>
            Here you can undo the connection to Song Carousel: 
            <a target="_blank" rel="noopener noreferrer" href="https://www.spotify.com/us/account/apps/" style={{ color: '#ffffff', textDecoration: 'underline' }}>Spotify Connected Apps</a>.
           </p>

        <button onClick={handleLogout} className="connect-minimal-logout-btn">
          Logout from Song Carousel
        </button>
      </div>
    </div>
  );
}

export default ConnectSpotify;
